import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'

const api = {
  userAddress: `${utils.hostname(
    'recvaddr'
  )}/recvaddrsvc/GetReceiveAddressList`,
  province: `${utils.hostname('address')}/addressview/GetProvinceList`,
  city: `${utils.hostname('address')}/addressview/GetCityList`,
  district: `${utils.hostname('address')}/addressview/GetDistrictList`,
  getNameById: `${utils.hostname('address')}/addressview/GetNameById`
}

export default {
  async getUserAddress({ commit, state }, { query, addrid }) {
    try {
      const userAddress_res = await fetch(`${api.userAddress}?${query}`, {
        // credentials: 'include'
      })
      const userAddressJson = await userAddress_res.json()
      let addr = null
      if (
        userAddressJson.errno === 0 &&
        userAddressJson.data &&
        userAddressJson.data.length > 0
      ) {
        // this.address = userAddressJson.data
        commit('setUserAddress', userAddressJson.data)
        const defaultAddress = userAddressJson.data.filter(
          ele => ele.property === 1
        )
        // let addr = null
        addr = userAddressJson.data[0]
        if (defaultAddress.length > 0) {
          addr = defaultAddress[0]
        }
        if (addrid >= 0) {
          const selected = userAddressJson.data.filter(
            ele => ele.addrid === parseInt(addrid, 10)
          )
          if (selected.length > 0) {
            addr = selected[0]
          }
        }
        // console.log(state.selectedAddress.regionid);
        if (
          state.selectedAddress.regionid === '' ||
          !state.selectedAddress.isLocated
        ) {
          // 如果regionid为空或者未定位
          commit('setSelectedAddress', addr)
        }
      } else if (userAddressJson.errno === 1024) {
        // 未登录
        throw new Error(userAddressJson.errno)
      }
      return addr
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async getProviceList({ commit }) {
    try {
      const provinces = await fetch(api.province)
      const provincesJson = await provinces.json()
      if (provincesJson.ProvinceList) {
        commit('setProvinces', provincesJson.ProvinceList)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getNameById({ commit }, { addressId }) {
    try {
      const query = queryString.stringify({
        addressId
      })
      const address = await fetch(`${api.getNameById}?${query}`)
      const addressJson = await address.json()
      if (addressJson.RetCode === 0) {
        return addressJson.Result
        // commit('setCities', addressJson.Result)
      } else {
        return null
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getCityList({ commit }, provinceId) {
    try {
      const query = queryString.stringify({
        provinceId
      })
      const cities = await fetch(`${api.city}?${query}`)
      const cityJson = await cities.json()
      if (cityJson.CityList) {
        commit('setCities', cityJson.CityList)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getDistrictList({ commit }, cityId) {
    try {
      const query = queryString.stringify({
        cityId
      })
      const districts = await fetch(`${api.district}?${query}`)
      const districtsJson = await districts.json()
      if (districtsJson.DistrictList) {
        commit('setDistrict', districtsJson.DistrictList)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getNearbyAddress({ state, commit }) {},
  async getSearchAddress({ state, commit }, keywords) {},
  async getGeoCode({ commit }, { address, city }) {}
}
